import { EarlyAccessProgramConfig } from '@monsido/services/early-access/early-access.types';

const earlyAccessProgram: EarlyAccessProgramConfig = {
    redesignAccessibility: ['test', 'preview'],
};

export const environment = {
    env: 'qa',
    production: true,
    earlyAccessProgram,
};
